import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { PrivatesAppointmentsApi } from "@/openapi/generated";

interface UseAppointmentAvailabilityGetProps {
  appointmentId: number;
  enabled?: boolean;
}

export const useAppointmentAvailabilityGet = ({
  appointmentId,
  enabled = true,
}: UseAppointmentAvailabilityGetProps) => {
  const accessToken = useAccessToken();

  const { data, isError, isLoading, isSuccess, isPending, refetch } = useQuery({
    queryKey: [QueryKeys.AppointmentAvailability, appointmentId],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(
        PrivatesAppointmentsApi,
        accessToken,
      );
      return service.apiAppointmentsIdAvailabilityGet({
        id: appointmentId,
      });
    },
    enabled: enabled && appointmentId > 0 && !!accessToken,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 2 * 60 * 1000,
    retry: false,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    refetch,
  };
};
